import { runInDevelopment, runInProduction } from '@/utils/runtime';
import { logs } from '@opentelemetry/api-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import {
  BatchLogRecordProcessor,
  LoggerProvider,
} from '@opentelemetry/sdk-logs';
import { CustomAttributesProcessor } from './custom-processor';

runInProduction(() => {
  const loggerProvider = new LoggerProvider({
    resource: resourceFromAttributes({
      'service.name': import.meta.env.VITE_OTEL_SERVICE_NAME,
      'deployment.environment': import.meta.env.VITE_OTEL_DEPLOYMENT_ENV,
    }),
    processors: [
      new CustomAttributesProcessor(),
      new BatchLogRecordProcessor(
        new OTLPLogExporter({
          url: import.meta.env.VITE_OTEL_LOGS_ENDPOINT,
        }),
      ),
    ],
  });

  logs.setGlobalLoggerProvider(loggerProvider);
});
